import { z } from 'zod';

import { email } from '../../../../utils/validation';

/**
 * Validation for a user-access row (existing rows and the new-user row).
 * Replaces the old `email.length < 13` disabled-button heuristic.
 */
export const userAccessSchema = z.object({
    email: email(),
});
